import firebase from "../services/firebaseService";
import Auth from "../services/authService";
import { i18next } from "../../base/i18n";

const firebaseAuth = firebase.auth();
const firebaseDatabase = firebase.database();

export const firebaseLogin = async(data) => {
    const { email, password } = data;
   return firebaseAuth
        .signInWithEmailAndPassword(email, password)
        .then((userCredential) => {
            // Signed in
            console.log("Firebase login success", userCredential);
            var user = userCredential.user;
            if (user.uid) {
                setFirebaseUserOnlineStatus();
            }
            return userCredential;
        })
        .catch((error) => {
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log("errorCode ====== ", errorCode);
            console.log("errorMessage ====== ", errorMessage);
            if (errorCode === "auth/user-not-found") {
                return firebaseSignup(data);
            }
            return false;
        });
};

export const firebaseSignup = async(data) => {
    const { email, password } = data;
   return firebaseAuth
        .createUserWithEmailAndPassword(email, password)
        .then((userCredential) => {
            // Signed in
            console.log("Firebase login success");
            var user = userCredential.user;
            if (user.uid) {
                setFirebaseUserOnlineStatus();
            }
            return userCredential;
        })
        .catch((error) => {
            var errorCode = error.code;
            var errorMessage = error.message;
            console.error("errorCode ====== ", errorCode);
            console.error("errorMessage ====== ", errorMessage);
            return false;
        });
};

export const SignInWIthToken = (token) => {
    firebaseAuth
        .signInWithCustomToken(token)
        .then((userCredential) => {
            // Signed in
            // var user = userCredential.user;
            return userCredential;
        })
        .catch((error) => {
            var errorCode = error.code;
            var errorMessage = error.message;
            console.error("errorCode ====== ", errorCode);
            console.error("errorMessage ====== ", errorMessage);
            return false;
        });
};

export function setFirebaseUserOnlineStatus() {
    const user = Auth.getUserDetail();
    const userStat = user.uniquecode ?? currentUser();
    let userStatusDatabaseRef = firebaseDatabase.ref("/status/" + userStat);
    firebaseDatabase.ref(".info/connected").on("value", (snapshot) => {
        if (snapshot.val() == false) {
            return false;
        }
        const isOnlineForDatabase = {
            online: true,
            last_changed: firebase.database.ServerValue.TIMESTAMP,
        };
        userStatusDatabaseRef.set(isOnlineForDatabase);
        userStatusDatabaseRef
            .onDisconnect()
            .update({ ...isOnlineForDatabase, online: false });
    });
}

export const isFirebaseUser = () => {
    firebaseAuth.onAuthStateChanged(async (user) => {
        if (user) {
            setFirebaseUserOnlineStatus();
        } else {
            console.error("User logged Out");
        }
    });
};

export const currentUser = () => { 
    var user = firebaseAuth.currentUser?.uid; 
    return user ?? false;
};

export function setLanguage(language = "en") {
    const user = Auth.getUserDetail();
    firebaseDatabase.ref("lang").child(user.uuid).set(language);
    i18next.changeLanguage(language);
}

export const SignoutUser = () => { 
    if (currentUser()) {
        let token = Auth.getUserAccessToken(); 
        if (!token) { 
            const user = firebaseAuth.currentUser; 
            user.delete().then(() => {
                // window.close();
            }).catch((error) => {
                console.log("firebase signout error for guest",error) 
            }); 
        } 
    }
};

export const __UserCredentialsUpdate = (__uid, __profile) => {
    firebaseDatabase
        .ref("/status/" + __uid)
        .once("value")
        .then((snapshot) => {
            if (snapshot.val() == false) {
                return false;
            }
            const data = snapshot.val();
            console.log("Changes", data);
        });
};
